// extracted by mini-css-extract-plugin
export default {"green600":"#6bba63","greyLight":"#eeeeee","filters":"TableFilters_filters__Z+XQv","tag":"TableFilters_tag__fnJOG","search":"TableFilters_search__RGciB"};